import React from "react";
import "./styles.scss";

const longText = "Isn't it a great idea to formalize family and friends lending? Image the possibilities!";
const shortText = "Namma.co - a concept worth looking into"
const url = "https://namma.co?utm_source=Namma"
const hashTag = "#namma #askOnNamma"


const renderReactions = () => {
  return (
    <div className="columns is-variable">

      <div className="column is-4">
        <div className="reaction white">
          We are supported by:
        </div>

      </div>
      <div className="column is-4">
        <div>
          <img src="/_Icons/BarclaysRiseLogo.svg" className="reaction white support-img">
          </img>
        </div>
      </div>
      <div className="column is-4">
        <div >
          <img src="/_Icons/GoldHouseLogo.svg" className="reaction white support-img">
          </img>
        </div>
      </div>
    </div >
  );
};

function HomePageShare() {
  return (
    <div className="HomepageFeatures background-green">
      <div className="reactions-container background-green">
        {renderReactions()}
      </div>
    </div>
  );
}

export default HomePageShare;
